import { useEffect, useState } from 'react';
import Header from './components/layout/Header/Header';
import Footer from './components/layout/Footer/Footer';
import Hero from './components/sections/Hero/Hero';
import About from './components/sections/About/About';
import Gallery from './components/sections/Gallery/Gallery';
import Services from './components/sections/Services/Services';
import Founder from './components/sections/Founder/Founder';
import Reviews from './components/sections/Reviews/Reviews';
import Experience from './components/sections/Experience/Experience';
import Consultation from './components/sections/Consultation/Consultation';
import Policies from './components/sections/Policies/Policies';
import Faq from './components/sections/Faq/Faq';
import Location from './components/sections/Location/Location';

export default function App() {
  const [requestedService, setRequestedService] = useState('');

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    if (window.location.hash) {
      window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    }

    const returnToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    returnToTop();
    window.requestAnimationFrame(returnToTop);

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  const startConsultation = (serviceId = '') => {
    setRequestedService(serviceId);
    window.requestAnimationFrame(() => {
      document.querySelector('#consulta')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return (
    <>
      <a className="skip-link" href="#contenido">Saltar al contenido</a>
      <Header onConsultation={() => startConsultation()} />
      <main id="contenido">
        <Hero onConsultation={() => startConsultation()} />
        <About />
        <Gallery />
        <Services onSelectService={startConsultation} />
        <Experience />
        <Consultation selectedServiceId={requestedService} />
        <Policies />
        <Faq />
        <Location />
        <Founder />
        <Reviews />
      </main>
      <Footer />
    </>
  );
}
